module.exports = __webpack_public_path__ + "img/pic-1@2x.c407eab7.png";